<script lang="ts">

    import type { LottiePlayer } from "@lottiefiles/lottie-player";

    export let speed: number = 1;

    let lottiePlayer: LottiePlayer;

    $: lottiePlayer?.setSpeed(speed);

</script>

<style lang="scss">

    .apple-walker {
        width: var(--width, 50%);
        max-width: 240px;
        position: relative;
        
        &::before {
            content: '';
            display: block;
            padding-top: 100%;
        }

        lottie-player {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

</style>

<div class="apple-walker">
    <lottie-player
        bind:this={lottiePlayer}
        src="/lotties/mascota_ajuste.json"
        speed={speed}
        loop
        autoplay></lottie-player>
</div>
